export const Permissions = Object.freeze({
    DRIVER_READ: "services:driver::read",
    DRIVER_WRITE: "services:driver::write",
    USERS_READ: "users::read",
    USERS_CREATE: "users::create",
    USERS_WRITE: "users::write",
    USERS_DELETE: "users::delete",
    EMPLOYEES_READ: "employees::read",
    COST_CENTER_READ: "cost_center::read",
    COST_CENTER_CREATE: "cost_center::create",
    COST_CENTER_DELETE: "cost_center::delete",
    COST_CENTER_EMPLOYEES_DELETE: "cost_center:employees::delete",
    SERVICES_READ: "services::read",
    SERVICES_CREATE: "services::create",
    UNASSIGN_SERVICES: "service::assign:edit", 
    CONTROL_TOWER_SERVICES_READ: "control_tower:services::read",
    CREATE_EMPLOYEE: "employees::create",
    DELETE_EMPLOYEE: "employees::delete",
    WRITE_EMPLOYEE: "employees::write",
});

export const TypeAddress = Object.freeze({
    ORIGIN: 'origin',
    DESTINY: 'destiny',
    ARRAY_EMPLOYEES: 'arrayEmployees',
    ARRAY_SCALES: 'arrayScales',
});

export const Languages = Object.freeze({
    ES: 'sp',
    EN: 'en',
});

export const TypeService = Object.freeze({
    REQUEST: "request",
    RESERVATIONS: "reservations",
    ASSIGNMENT: "assignment",
});

export const BookingType = Object.freeze({
    CLOSED: "CLOSED",
    OPEN: "OPEN",
    ARRIVAL: "ARRIVAL",
    LEAVING: "LEAVING",
    FINISHED: "FINISHED",
});

export const BookingStatus = Object.freeze({
    ASSIGNED: "ASSIGNED",
    REJECTED: "REJECTED",
    FINISHED: "FINISHED",
    DELETED: "DELETED",
    STARTED: "STARTED",
});

export const FilterType = Object.freeze({
    COMPANY: 'company',
    STATUS: 'status',
    TYPE: 'type',
    CODE: 'code',
    PAGE: 'page',
    PLACE: 'place_id',
    PLATE: 'plate',
    SCHEDULED: 'scheduled_type',
});

export const VisibilityTypes = Object.freeze({
    COMPANY: "company",
    COST_CENTER: "costCenter",
    GENERAL: "general",
    DATE_HOUR: "datehour",
    ADDITIONAL_NOTE: "additionalNote",
    TYPE_SERVICE: "typeService",
    ADDRESSES: "addresses",
    UNITS: "units",
    IDTAG: "idtag",
    EMPLOYEES: "employees",
    SCALES: "scales",
    SELECTED_ROUTE: "selectedRoute",
    PASSENGERS: "passengers",
});

export const AlertMessages = Object.freeze({
    SUCCESS: "SuccessRequestService",
    ERROR: "ErrorRequestService",
});

export const DataActions = Object.freeze({
    GET_REQUESTS: "GET_REQUESTS",
    GET_BOOKINGS: "GET_BOOKINGS",
    GET_DRIVERS: "GET_DRIVERS",
});

export const DriverStatus = Object.freeze({
    ALL: "ALL",
    FREE: "FREE",
});

export const UserActions = Object.freeze({
    ADD_USER: "add_user",
    ACTIVATE_USER: "activate_user",
    DEACTIVATE_USER: "deactivate_user",
    DELETE_USER: "delete_user",
});

export const StreamType = Object.freeze({
    REQUEST_CREATED: 'REQUEST_CREATED',
    REQUEST_DELETED: 'REQUEST_DELETED',
    REQUEST_UPDATED: 'REQUEST_UPDATED',
    BOOKING_CREATED: 'BOOKING_CREATED',
    BOOKING_DELETED: 'BOOKING_DELETED',
    BOOKING_UPDATED: 'BOOKING_UPDATED',
    DRIVER_ONLINE: 'DRIVER_ONLINE',
    DRIVER_OFFLINE: 'DRIVER_OFFLINE',
});

export const ServiceStatus = Object.freeze({
    FINISHED: "FINISHED",
    ASSIGNED: "ASSIGNED",
    REJECTED: "REJECTED",
    UNASSIGNED: "UNASSIGNED",
    DELETED: "DELETED",
    STARTED: "STARTED",
});

export const EmployeeStatus = Object.freeze({
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
});

export const UserType = Object.freeze({
    STAFF: "STAFF",
    USER: "USER",
    ADMIN: "ADMIN",
    EMPLOYEE: "EMPLOYEE",
});

export const Environments = Object.freeze({
    DEVELOPMENT: "development",
    STAGING: "staging",
    PRODUCTION: "production",
});

export const ServiceEventType = Object.freeze({
    CREATED: "SERVICE_CREATED",
    STARTED: "SERVICE_STARTED",
    COMPLETED: "SERVICE_COMPLETED",
    CANCELLED: "SERVICE_CANCELLED",
    ORIGIN_PICKUP: "ORIGIN_PICKUP",
    DESTINATION_DROPOFF: "DESTINATION_DROPOFF"
});

export const ServiceScheduledType = Object.freeze({
    ON_DEMAND: "ON_DEMAND",
    RESERVED: "RESERVED",
});

export const RoutingServiceType = Object.freeze({
    AFORO: "Aforo",
    DESAFORO: "Desaforo",
    NORMAL: "Normal",
});
